import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const FALLBACK_IMAGE =
  "https://images.pexels.com/photos/9998511/pexels-photo-9998511.jpeg?auto=compress&cs=tinysrgb&w=900";

export const imgUrl = (src) => {
  if (!src) return FALLBACK_IMAGE;
  if (src.startsWith("http")) return src;
  return `${BACKEND_URL}${src}`;
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sparkle_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatApiError = (detail) => {
  if (detail == null) return "Xəta baş verdi. Yenidən cəhd edin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const formatPrice = (v) => `${Number(v).toFixed(2)} ₼`;

// Qonaq müştəri sifarişini yalnız gizli açarla görə bilir. Açar sifariş
// yaradılanda bir dəfə qaytarılır və brauzerdə saxlanılır.
const ORDER_TOKENS_KEY = "sparkle_order_tokens";

const readOrderTokens = () => {
  try {
    return JSON.parse(localStorage.getItem(ORDER_TOKENS_KEY) || "{}");
  } catch {
    return {};
  }
};

export const saveOrderToken = (orderNumber, token) => {
  if (!orderNumber || !token) return;
  try {
    const all = readOrderTokens();
    all[orderNumber] = token;
    localStorage.setItem(ORDER_TOKENS_KEY, JSON.stringify(all));
  } catch {
    // localStorage bağlıdırsa sifariş yalnız hesabdan görünəcək
  }
};

export const getOrderToken = (orderNumber) => readOrderTokens()[orderNumber] || null;

// epoint ödənişdən sonra sabit səhifəyə qayıdır (/payment-success). Sifariş
// nömrəsi parametrdə gəlməzsə, sonuncu sifarişi bu yaddaşdan tapırıq.
const LAST_ORDER_KEY = "sparkle_last_order";

export const saveLastOrderNumber = (orderNumber) => {
  try {
    if (orderNumber) localStorage.setItem(LAST_ORDER_KEY, orderNumber);
  } catch {
    // localStorage bağlıdırsa sifariş yalnız hesabdan görünəcək
  }
};

export const getLastOrderNumber = () => {
  try {
    return localStorage.getItem(LAST_ORDER_KEY) || null;
  } catch {
    return null;
  }
};

// Son çatdırılma ünvanı — qonaq müştəri hər dəfə yenidən yazmasın (təsisçi
// qərarı, 2026-10-20). YALNIZ bu cihazda qalır: qonağın ünvanını serverdə
// telefon nömrəsinə görə açmaq olmazdı (nömrə təsdiqlənmir — yad adam görərdi).
// Girişli müştərinin ünvanları serverdən gəlir (`/my/addresses`).
const LAST_ADDRESS_KEY = "sparkle_last_address";

export const saveLastAddress = (addr) => {
  try {
    localStorage.setItem(LAST_ADDRESS_KEY, JSON.stringify({ ...addr, saved_at: Date.now() }));
  } catch {
    // yaddaş bağlıdırsa müştəri növbəti dəfə yenidən yazır
  }
};

export const getLastAddress = () => {
  try {
    const a = JSON.parse(localStorage.getItem(LAST_ADDRESS_KEY) || "null");
    return a && a.street ? a : null;
  } catch {
    return null;
  }
};

export const clearLastAddress = () => {
  try {
    localStorage.removeItem(LAST_ADDRESS_KEY);
  } catch {
    // heç nə
  }
};

/**
 * Cihaza uyğun ödəniş cüzdanının adı.
 *
 * Telefonda müştəri yalnız istifadə edə biləcəyi üsulu görməlidir:
 * iPhone-da "Apple Pay", Android-də "Google Pay".
 *
 * KOMPÜTERDƏ isə hər ikisi mümkündür. 2025-ci ilin fevralından Apple Pay
 * yalnız Safari-də deyil, Chrome/Firefox/Edge-də də işləyir (müştəri ekrandakı
 * QR kodu iPhone-u ilə oxudur). Ona görə masaüstündə hər iki ad göstərilir —
 * birini gizlətsək müştəri işləyən üsuldan məhrum olardı.
 *
 * Qaytarır: "Apple Pay" | "Google Pay" | "Apple Pay / Google Pay"
 */
export const walletBrand = () => {
  if (typeof window === "undefined") return "Apple Pay / Google Pay";
  const ua = window.navigator?.userAgent || "";

  // Telefon və planşet — bir cihazda yalnız bir cüzdan olur.
  if (/iPhone|iPad|iPod/i.test(ua)) return "Apple Pay";
  if (/Android/i.test(ua)) return "Google Pay";

  // Mac + Safari: brauzerin özündən soruşuruq, ən dəqiq cavab budur.
  try {
    if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
      return "Apple Pay";
    }
  } catch {
    // canMakePayments bəzi mühitlərdə xəta atır — aşağıdakı cavaba keçirik
  }

  // Qalan masaüstü hallar: hər ikisi mümkündür.
  return "Apple Pay / Google Pay";
};

export default api;
